import {Component} from "@angular/core";
import {MESSAGES} from "../../../common/constants";

@Component({
  selector: 'app-client-skipped-inspections',
  templateUrl: './client-skipped-inspections.component.html',
  styleUrls: ['./client-skipped-inspections.component.css']
})
export class ClientSkippedInspectionsComponent {
  protected readonly texts = MESSAGES;
}
